import React from 'react';
import { Chip, Tooltip, Box, Typography, LinearProgress } from '@mui/joy';
import { getOpportunityScoreTier } from '../../types/stormtracker';

interface OpportunityScoreBadgeProps {
  score: number;
  size?: 'sm' | 'md' | 'lg';
  showProgress?: boolean;
}

export const OpportunityScoreBadge: React.FC<OpportunityScoreBadgeProps> = ({
  score,
  size = 'sm',
  showProgress = false,
}) => {
  const tier = getOpportunityScoreTier(score);

  const tooltipContent = (
    <Box sx={{ p: 1 }}>
      <Typography level="body-sm" fontWeight="bold">
        Opportunity Score: {score}/100
      </Typography>
      <Typography level="body-xs" sx={{ color: 'text.secondary', mt: 0.5 }}>
        {tier.label} priority for roof damage leads
      </Typography>
    </Box>
  );

  if (showProgress) {
    return (
      <Tooltip title={tooltipContent} placement="top">
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 100 }}>
          <LinearProgress
            determinate
            value={score}
            color={tier.color}
            sx={{ flex: 1, height: 8, borderRadius: 4 }}
          />
          <Typography level="body-sm" fontWeight="bold" sx={{ minWidth: 32 }}>
            {score}
          </Typography>
        </Box>
      </Tooltip>
    );
  }

  return (
    <Tooltip title={tooltipContent} placement="top">
      <Chip
        size={size}
        color={tier.color}
        variant="soft"
        sx={{ fontWeight: 'bold' }}
      >
        {score}
      </Chip>
    </Tooltip>
  );
};

export default OpportunityScoreBadge;
